import axios from "axios";
import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Table, Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import { handle401 } from "../../../utils/handleAuthError";

const BASE_URL = "https://sutmmg.codydeasoftech.in/api";

const IssueJobWork = () => {
  const [showModal, setShowModal] = useState(false);

  const [showSingleModal, setShowSingleModal] = useState(false);
  const [showMultipleModal, setShowMultipleModal] = useState(false);

  const [items, setItems] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [itemId, setItemId] = useState("");
  const [sizeId, setSizeId] = useState("");
  const [fabricList, setFabricList] = useState([]);
  const [actionList, setActionList] = useState([]);
  const [selectedActions, setSelectedActions] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [issueToList, setIssueToList] = useState([]);
  const [measurements, setMeasurements] = useState([]);
  const [loadingMeasurements, setLoadingMeasurements] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedVendorType, setSelectedVendorType] = useState("");
  const [loading, setLoading] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [jobIssueDetails, setJobIssueDetails] = useState([]);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const handleOpenDetailsModal = () => setShowDetailsModal(true);
  const handleCloseDetailModal = () => setShowDetailsModal(false);

  const today = new Date().toISOString().split("T")[0]; // "YY

  useEffect(() => {
  if (showSingleModal || showMultipleModal) {
    const today = new Date().toISOString().split("T")[0];

    setFormData(prev => ({
      ...prev,
      issue_date: today,
    }));
  }
}, [showSingleModal, showMultipleModal]);


  const orderedActions = actionList
    .filter(
      (action) =>
        Number(action.is_show_on_issue) === 1 && Number(action.id) !== 2 && Number(action.id) !==7,
    )
    .sort((a, b) => a.ordering - b.ordering);

  const formatDate = (date) => {
    if (!date) return "-";

    const d = new Date(date);
    if (isNaN(d)) return "-";

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}-${month}-${year}`; // DD/MM/YYYY
  };
  const emptyItemBlock = {
    fabric_type: "",
    item_id: "",
    measurements: [],
    jobIssueDetails: [],
    loading: false,
    vendor_id: "",
    vendorList: [],
    selectedActions: [], // ✅ ADD THIS
    member_id: "",
    memberList: [],
    selectedMembers: [],
  };

  const [itemBlocks, setItemBlocks] = useState([emptyItemBlock]);

  const handleAddMoreItem = () => {
    setItemBlocks((prev) => [...prev, emptyItemBlock]);
  };
  const [issues, setIssues] = useState([]);

  const [formData, setFormData] = useState({
    issue_date: today,
    item: "",
    size: "",
    qty: "",
    issue_to: "",
    beneficiary_id: "",
    tentative_return_date: "",
  });

  /* ================= FETCH ITEMS ================= */
  const fetchItems = async () => {
    try {
  const token = localStorage.getItem("token");

      const res = await axios.post(
        `${BASE_URL}/itemsList`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const filteredItems =
        res.data?.data?.itemsList?.filter(
          (item) => Number(item.status) !== 0,
        ) || [];

      setItems(filteredItems);
    } catch (error) {
      console.error("Items API Error:", error);
      if (handle401(error)) return;

      Swal.fire(
        "Alert",
        error?.response?.data?.message || "Failed to load items",
        "error",
      );
    }
  };

  const fetchMembersByVendor = async (vendorId, index = null) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/memberList`,
        { shg_id: vendorId },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      const memberList = response.data?.data || [];

      setItemBlocks((prev) =>
        prev.map((block, i) => {
          // 🔥 If index exists → Multiple Vendor
          if (index !== null) {
            return i === index ? { ...block, memberList } : block;
          }

          // 🔥 If no index → Single Vendor
          return { ...block, memberList };
        }),
      );
    } catch (error) {
      console.error("Error fetching members:", error);
    }
  };

  const fetchActionList = async () => {
    try {
  const token = localStorage.getItem("token");

      const res = await axios.get(
        `${BASE_URL}/jobWorkTypeList`,

        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const rawList = res.data?.data.jobWorkTypeList || [];

      setActionList(rawList);
    } catch (error) {
      console.error("Action list error", error);
      if (handle401(error)) return;

      Swal.fire(
        "Alert",
        error?.response?.data?.message || "Failed to load action list",
        "error",
      );
    }
  };

  const fetchVendorType = async () => {
    try {
  const token = localStorage.getItem("token");

      const res = await axios.post(
        `${BASE_URL}/vendorTypesList`,
        {},
        { headers: { Authorization: `Bearer ${token}` } },
      );

      console.log("Vendor Types:", res.data?.data);
      setIssueToList(res.data?.data || []);
    } catch (error) {
      if (handle401(error)) return;

      console.error("Vendor type fetch error", error);
      Swal.fire("Alert", "Failed to load vendor types", "error");
    }
  };

  const fetchVendorsByType = async (vendorTypeId, index = null) => {
    try {
  const token = localStorage.getItem("token");

      const res = await axios.post(
        `${BASE_URL}/vendorsList`,
        { vendor_type_id: Number(vendorTypeId) },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const vendors = res.data?.data || [];

      // 👉 If index is provided → Multiple Vendor modal
      if (index !== null) {
        setItemBlocks((prev) =>
          prev.map((block, i) =>
            i === index ? { ...block, vendorList: vendors } : block,
          ),
        );
      }
      // 👉 If index is NOT provided → Single Vendor modal
      else {
        setVendorList(vendors);
      }
    } catch (error) {
      if (handle401(error)) return;
    }
  };

  useEffect(() => {
    fetchVendorType();
  }, []);

  const resetModal = () => {
    setFormData({
      issue_date: "",
      item: "",
      size: "",
      qty: "",
      issue_to: "",
      vendor_id: "",
      beneficiary_id: "",
      tentative_return_date: "",
    });
    setItemBlocks([emptyItemBlock]);
    setSelectedActions([]);
    setVendorList([]);
  };

  const handleCloseModal = () => {
    resetModal();
    setShowMultipleModal(false);
    setShowSingleModal(false);
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = start + maxVisible - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  const fetchItemWiseOtherJobIssueData = async (itemId, index,jobWorkTypeIds = []) => {
    try {
  const token = localStorage.getItem("token");
      setItemBlocks((prev) =>
        prev.map((b, i) => (i === index ? { ...b, loading: true } : b)),
      );

      const res = await axios.post(
        `${BASE_URL}/getItemWiseOtherJobIssueData`,
        { item_id: itemId ,
            job_work_type_ids: jobWorkTypeIds
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const rows = res.data?.data?.overView || [];

      setItemBlocks((prev) =>
        prev.map((b, i) =>
          i === index ? { ...b, jobIssueDetails: rows, loading: false } : b,
        ),
      );
    } catch (err) {
      if (handle401(err)) return;

      Swal.fire("Alert", "Failed to load job issue details", "error");

      setItemBlocks((prev) =>
        prev.map((b, i) =>
          i === index ? { ...b, jobIssueDetails: [], loading: false } : b,
        ),
      );
    }
  };

//   const handleSaveSinglevendor = async () => {
//     const payload = {
//       issue_date: formData.issue_date,
//       vendor_type: String(selectedVendorType),
//       vendor: String(formData.vendor_id),
//       //   jobs: orderedActions.map((a) => Number(a.id)),
//       jobs: selectedActions.map((id) => Number(id)),
//       items: itemBlocks.map((b) => Number(b.item_id)),
//       date_of_start_returning: formData.tentative_return_date,
//     };

//     try {
//   const token = localStorage.getItem("token");

//       const res = await axios.post(`${BASE_URL}/issueOtherJobWorks`, payload, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       if (res.data?.status) {
//         Swal.fire("Success", res.data.message, "success");

//         handleCloseModal();

//         const newTotal = totalRecords + 1;
//         const lastPage = Math.ceil(newTotal / perPage);

//         setTimeout(() => {
//           issuedJobWorksList({
//             page: lastPage,
//             vendorTypeId: "",
//             vendorId: "",
//           });
//         }, 0);
//       } else {
//         Swal.fire("Alert", res.data?.message || "Failed to issue job", "error");
//       }
//     } catch (error) {
//       if (handle401(error)) return;

//       Swal.fire(
//         "Alert",
//         error?.response?.data?.message || "Something went wrong",
//         "error",
//       );
//     }
//   };

const handleSaveSinglevendor = async () => {
  const payload = {
    issue_date: formData.issue_date,
    vendor_type: String(selectedVendorType),
    vendor: String(formData.vendor_id),
    jobs: selectedActions.map((id) => Number(id)),
    items: itemBlocks.map((b) => Number(b.item_id)),
    date_of_start_returning: formData.tentative_return_date,
  };

  try {
    setSubmitLoading(true); // 🔥 START LOADER

const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/issueOtherJobWorks`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (res.data?.status) {
      Swal.fire("Success", res.data.message, "success");

      handleCloseModal();

      const newTotal = totalRecords + 1;
      const lastPage = Math.ceil(newTotal / perPage);

      setTimeout(() => {
        issuedJobWorksList({
          page: lastPage,
          vendorTypeId: "",
          vendorId: "",
        });
      }, 0);
    } else {
      Swal.fire("Alert", res.data?.message || "Failed to issue job", "error");
    }
  } catch (error) {
    if (handle401(error)) return;

    Swal.fire(
      "Alert",
      error?.response?.data?.message || "Something went wrong",
      "error"
    );
  } finally {
    setSubmitLoading(false);
  }
};

//   const handleSaveMultipleVendor = async () => {
//     const payload = {
//       issue_date: formData.issue_date,

//       items: itemBlocks.map((b) => Number(b.item_id)),
//       vendor_types: itemBlocks.map((b) => Number(b.issue_to)),
//       vendors: itemBlocks.map((b) => Number(b.vendor_id)),
//       jobs: itemBlocks.map((b) =>
//         (b.selectedActions || []).map((id) => Number(id)),
//       ),
//       members: itemBlocks.map((b) =>
//         (b.selectedMembers || []).map((id) => Number(id)),
//       ),
//       date_of_start_returning: formData.tentative_return_date,
//     };

//     try {
//   const token = localStorage.getItem("token");

//       const res = await axios.post(
//         `${BASE_URL}/issueOtherJobWorksNew`,
//         payload,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         },
//       );

//       if (res.data?.status) {
//         Swal.fire("Success", res.data.message, "success");

//         handleCloseModal();

//         const newTotal = totalRecords + 1;
//         const lastPage = Math.ceil(newTotal / perPage);

//         setTimeout(() => {
//           issuedJobWorksList({
//             page: lastPage,
//             vendorTypeId: "",
//             vendorId: "",
//           });
//         }, 0);
//       } else {
//         Swal.fire("Alert", res.data?.message || "Failed to issue job", "error");
//       }
//     } catch (error) {
//       if (handle401(error)) return;

//       Swal.fire(
//         "Alert",
//         error?.response?.data?.message || "Something went wrong",
//         "error",
//       );
//     }
//   };


const handleSaveMultipleVendor = async () => {
  const payload = {
    issue_date: formData.issue_date,
    items: itemBlocks.map((b) => Number(b.item_id)),
    vendor_types: itemBlocks.map((b) => Number(b.issue_to)),
    vendors: itemBlocks.map((b) => Number(b.vendor_id)),
    jobs: itemBlocks.map((b) =>
      (b.selectedActions || []).map((id) => Number(id))
    ),
    members: itemBlocks.map((b) =>
      (b.selectedMembers || []).map((id) => Number(id))
    ),
    date_of_start_returning: formData.tentative_return_date,
  };

  try {
    setSubmitLoading(true); // 🔥 START LOADER

const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/issueOtherJobWorksNew`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (res.data?.status) {
      Swal.fire("Success", res.data.message, "success");

      handleCloseModal();

      const newTotal = totalRecords + 1;
      const lastPage = Math.ceil(newTotal / perPage);

      setTimeout(() => {
        issuedJobWorksList({
          page: lastPage,
          vendorTypeId: "",
          vendorId: "",
        });
      }, 0);
    } else {
      Swal.fire("Alert", res.data?.message || "Failed to issue job", "error");
    }
  } catch (error) {
    if (handle401(error)) return;

    Swal.fire(
      "Alert",
      error?.response?.data?.message || "Something went wrong",
      "error"
    );
  } finally {
    setSubmitLoading(false); // 🔥 STOP LOADER
  }
};

  const issuedJobWorksList = async ({
    page = 1,
    vendorTypeId = selectedVendorType,
    vendorId = formData.vendor_id,
    jobWorkIds = selectedActions,
  } = {}) => {
    try {
      setLoading(true);

  const token = localStorage.getItem("token");

      const res = await axios.post(
        `${BASE_URL}/getIssuedJobWorksList`,
        {
          vendor_type_id: vendorTypeId || "",
          vendor_id: vendorId || "",
          job_work_type_ids: [3, 4, 5, 6, 7],
          page,
          per_page: perPage,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (res.data?.status) {
        setIssues(res.data.data || []);
        setTotalRecords(res.data.total_records || 0);
        setTotalPages(Math.ceil((res.data.total_records || 0) / perPage));
        setPage(page);
      } else {
        setIssues([]);
        setTotalRecords(0);
        setTotalPages(1);
      }
    } catch (err) {
      if (handle401(err)) return;
      console.error("Issued Job Works List Error:", err);
      setIssues([]);
    } finally {
      setLoading(false);
    }
  };

  const theadStyle = {
    padding: "5px",
    fontWeight: "600",
    letterSpacing: "0.5px",
    borderTopLeftRadius: "10px",
    backgroundColor: "#edf7fe",
    height: "10px",
    borderBottom: "1px solid black",
    borderTop: "1px solid black",
    textAlign: "center",
  };

  useEffect(() => {
    issuedJobWorksList({ page });
  }, [page, perPage]);

  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>
      {/* HEADER */}
      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div className="px-4 py-3 text-white" style={{ background: "#1565C1" }}>
          <h5 className="mb-0 fw-bold">
            <i className="fa-solid fa-scissors"></i> Issue Stitching and Other
            Job Works
          </h5>
        </div>

        <Card.Body className="px-4 py-4">
          <Row className="align-items-center">
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">
                  Organisation Type
                </Form.Label>
                <Form.Select
                  value={selectedVendorType}
                  onChange={(e) => {
                    const vendorTypeId = e.target.value;

                    setSelectedVendorType(vendorTypeId);
                    setFormData({ ...formData, vendor_id: "" });

                    if (vendorTypeId) {
                      fetchVendorsByType(vendorTypeId);
                    } else {
                      setVendorList([]);
                    }
                  }}
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                >
                  <option value="">Select Organisation type</option>
                  {issueToList.map((v) => (
                    <option key={v.id} value={v.id}>
                      {v.vendor_type_short_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">
                  Organisation
                </Form.Label>
                <Form.Select
                  value={formData.vendor_id || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, vendor_id: e.target.value })
                  }
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                  disabled={!selectedVendorType || vendorList.length === 0} // disable if no type selected
                >
                  <option value="">Select Organisation</option>
                  {vendorList.map((v) => (
                    <option key={v.id} value={v.id}>
                      {v.vendors_master_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">
                  Record Showing
                </Form.Label>

                <Form.Select
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                  value={perPage}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    setPerPage(value);
                    setPage(1);
                  }}
                >
                  <option value={10}>10 Per Page</option>
                  <option value={25}>25 Per Page</option>
                  <option value={50}>50 Per Page</option>
                  <option value={100}>100 Per Page</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={4} className="d-flex gap-3 mt-3">
              {/* SEARCH */}
              <Button
                className="w-50 fw-semibold text-white"
                style={{
                  background: "#1565C1",
                  border: "none",
                  borderRadius: "10px",
                  transition: "0.3s",
                }}
                onMouseEnter={(e) => (e.target.style.background = "#0D47A1")}
                onMouseLeave={(e) => (e.target.style.background = "#1565C1")}
                onClick={() => issuedJobWorksList()}
              >
                <i className="fa-solid fa-magnifying-glass me-2"></i> Search
              </Button>

              {/* RESET */}
              <Button
                className="w-50 fw-semibold text-white"
                style={{
                  background: "#E53935",
                  border: "none",
                  borderRadius: "10px",
                  transition: "0.3s",
                }}
                onMouseEnter={(e) => (e.target.style.background = "#D32F2F")}
                onMouseLeave={(e) => (e.target.style.background = "#E53935")}
                onClick={() => {
                  // Reset pagination
                  setPage(1);
                  setPerPage(10);

                  // Clear filters
                  setSelectedVendorType(""); // vendor type dropdown
                  setFormData({
                    ...formData,
                    vendor_id: "", // vendor dropdown
                  });
                  setSelectedActions([]); // selected job works

                  // Reset the list with default parameters
                  issuedJobWorksList({
                    page: 1,
                    vendorTypeId: "",
                    vendorId: "",
                    jobWorkIds: [],
                  });

                  // Clear vendor list as vendor type is cleared
                  setVendorList([]);
                }}
              >
                <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* ADD BUTTON */}
      <Button
        className="mb-3 text-white me-4"
        style={{
          background: "linear-gradient(135deg, #2E7D32, #66BB6A)",
          borderRadius: "10px",
        }}
        onClick={() => {
          resetModal();
          fetchItems();
          fetchActionList();
          setShowSingleModal(true);
        }}
      >
        <i className="fa-solid fa-circle-plus me-2"></i> Issue Stitching and
        Other Job Works (Single Organisation)
      </Button>

      <Button
        className="mb-3 text-white"
        style={{
          background: "linear-gradient(135deg, #2E7D32, #66BB6A)",
          borderRadius: "10px",
        }}
        onClick={() => {
          resetModal();
          fetchItems();
          fetchActionList();
          setShowMultipleModal(true);
        }}
      >
        <i className="fa-solid fa-circle-plus me-2"></i> Issue Stitching and
        Other Job Works (Multiple Organisation)
      </Button>

      {/* TABLE */}

      {loading && (
  <div className="loader-wrapper text-center my-4">
    <div className="blue-spinner"></div>
    <p className="loading-text">Loading...</p>
  </div>
)}

{!loading && (
      <Card className="border-0">
        <Table hover striped responsive>
          <thead>
            <tr className="text-center">
              <th style={theadStyle}>SL</th>
              <th style={theadStyle}>Issue Date</th>
              <th style={theadStyle}>Organisation Type</th>
              <th style={theadStyle}>Organisation</th>
              <th style={theadStyle}>Members</th>
              <th style={theadStyle}>Job Works</th>
              <th style={theadStyle}>Tentative Return</th>
              {/* <th style={theadStyle}>Action</th> */}
            </tr>
          </thead>
          <tbody>
            {issues.length > 0 ? (
              issues.map((row, i) => (
                <tr key={i} className="text-center">
                  <td className="text-center">
                    {(page - 1) * perPage + i + 1}
                  </td>
                  <td>{formatDate(row.issue_date)}</td>
                  <td>{row.vendor_type_short_name}</td>
                  <td>{row.vendors_master_name}</td>
<td>{row.members || "NA"}</td>
                  <td style={{ width: "230px" }}>
                    {row.jobs?.map((j) => j.action_name).join(", ") || "-"}
                  </td>

                  <td>{formatDate(row.date_of_start_returning)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        {totalPages > 1 && (
          <div className="d-flex justify-content-center mt-4">
            <nav>
              <ul className="pagination shadow-sm">
                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => issuedJobWorksList({ page: 1 })}
                  >
                    «
                  </button>{" "}
                </li>

                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => issuedJobWorksList({ page: page - 1 })}
                  >
                    ‹
                  </button>{" "}
                </li>

                {getPageNumbers().map((p) => (
                  <li
                    key={p}
                    className={`page-item ${page === p ? "active" : ""}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => issuedJobWorksList({ page: p })}
                    >
                      {p}
                    </button>
                  </li>
                ))}

                <li
                  className={`page-item ${
                    page === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => issuedJobWorksList({ page: page + 1 })}
                  >
                    ›
                  </button>{" "}
                </li>

                <li
                  className={`page-item ${
                    page === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => issuedJobWorksList({ page: totalPages })}
                  >
                    »
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </Card>
)}

      {/* DETAILS MODAL */}
      <Modal
        show={showDetailsModal}
        onHide={handleCloseDetailModal}
        size="xl"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header
          closeButton
          style={{ background: "#1565C1", color: "#fff" }}
        >
          <Modal.Title>Job Work Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Table hover striped responsive>
            <thead>
              <tr>
                <th>SL</th>
                <th>Vendor</th>
                <th>Item</th>
                <th>Size</th>
                <th>Amount</th>
                <th>Balance</th>
                <th>Type</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {/* Use real data here */}
              {issues.length > 0 ? (
                issues.map((t, idx) => (
                  <tr key={idx} className="text-center">
                    <td>{idx + 1}</td>
                    <td>{t.vendors_master_name}</td>
                    <td>{t.item_name || "-"}</td>
                    <td>{t.size || "-"}</td>
                    <td>₹ {t.amount || 0}</td>
                    <td style={{ color: "green", fontWeight: 600 }}>
                      ₹ {t.current_amount || 0}
                    </td>
                    <td>{t.type || "-"}</td>
                    <td>{formatDate(t.created_at)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDetailModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/*Single MODAL */}
      <Modal
        show={showSingleModal}
        size="lg"
        onHide={handleCloseModal}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header
          closeButton
          style={{ background: "#3399ff", color: "#fff" }}
        >
          <Modal.Title>
            Issue Stitching and Other Job Works (Single Organisation)
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Issue Date */}
          <Row>
            <Col md={4}>
              <Form.Group className="mb-2">
                <Form.Label>
                  Issue Date <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  value={formData.issue_date}
                  onChange={(e) =>
                    setFormData({ ...formData, issue_date: e.target.value })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              {/* Issue To */}
              <Form.Group className="mb-2">
                <Form.Label>
                  Organisation Type <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  value={selectedVendorType}
                  onChange={(e) => {
                    const vendorTypeId = e.target.value;

                    setSelectedVendorType(vendorTypeId); // track selected type
                    setFormData({ ...formData, vendor_id: "" }); // reset vendor selection

                    if (vendorTypeId) {
                      fetchVendorsByType(vendorTypeId); // fetch vendors for this type
                    } else {
                      setVendorList([]); // clear if no type selected
                    }
                  }}
                >
                  <option value="">Select</option>

                  {issueToList.map((i) => (
                    <option key={i.id} value={i.id}>
                      {i.vendor_type_short_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">
                  Organisation
                </Form.Label>
                <Form.Select
                  value={formData.vendor_id || ""}
                  onChange={(e) => {
                    const value = e.target.value;

                    setFormData({ ...formData, vendor_id: value });

                    if (value) {
                      fetchMembersByVendor(value, 0); // ✅ FIX (index 0)
                    }
                  }}
                  disabled={!selectedVendorType || vendorList.length === 0}
                >
                  <option value="">Select Organisation</option>
                  {vendorList.map((v) => (
                    <option key={v.id} value={v.id}>
                      {v.vendors_master_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          {itemBlocks[0]?.memberList?.length > 0 && (
            <div className="mt-3">
              <h6>Members</h6>

              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        checked={
                          itemBlocks[0].selectedMembers?.length ===
                            itemBlocks[0].memberList.length &&
                          itemBlocks[0].memberList.length > 0
                        }
                        onChange={(e) => {
                          const checked = e.target.checked;

                          setItemBlocks((prev) =>
                            prev.map((b, i) =>
                              i === 0
                                ? {
                                    ...b,
                                    selectedMembers: checked
                                      ? b.memberList.map((m) => m.user_id)
                                      : [],
                                  }
                                : b,
                            ),
                          );
                        }}
                      />
                    </th>
                    <th>Name</th>
                    <th>Mobile</th>
                    <th>Beneficiary ID</th>
                  </tr>
                </thead>

                <tbody>
                  {itemBlocks[0].memberList.map((member) => (
                    <tr key={member.user_id}>
                      <td>
                        <input
                          type="checkbox"
                          checked={itemBlocks[0].selectedMembers?.includes(
                            member.user_id,
                          )}
                          onChange={(e) => {
                            const checked = e.target.checked;

                            setItemBlocks((prev) =>
                              prev.map((b, i) => {
                                if (i !== 0) return b;

                                let updated = [...(b.selectedMembers || [])];

                                if (checked) {
                                  updated.push(member.user_id);
                                } else {
                                  updated = updated.filter(
                                    (id) => id !== member.user_id,
                                  );
                                }

                                return { ...b, selectedMembers: updated };
                              }),
                            );
                          }}
                        />
                      </td>
                      <td>{member.name}</td>
                      <td>{member.mobile}</td>
                      <td>{member.beneficiary_id}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Selected Jobs</Form.Label>

            <div
              style={{
                maxHeight: "220px",
                overflowY: "auto",
                borderRadius: "8px",
                padding: "10px",
              }}
            >
              {orderedActions.length > 0 ? (
                <Row>
                  {orderedActions.map((action, index) => {
                    const isChecked = selectedActions.includes(action.id);

                    // Sequential logic
                    const isDisabled =
                      !isChecked && selectedActions.length !== index;

                    return (
                      <Col md={4} key={action.action_master_id}>
                        <Form.Check
                          type="checkbox"
                          label={action.action_name}
                          checked={isChecked}
                          disabled={isDisabled}
                          onChange={(e) => {
                            const checked = e.target.checked;

                            if (checked) {
                              setSelectedActions((prev) => [
                                ...prev,
                                action.id,
                              ]);
                            } else {
                              // Remove this and all after it
                              const newSelected = selectedActions.slice(
                                0,
                                index,
                              );
                              setSelectedActions(newSelected);
                            }
                          }}
                          className="mb-2"
                        />
                      </Col>
                    );
                  })}
                </Row>
              ) : (
                <div className="text-muted text-center">No Actions Found</div>
              )}
            </div>
          </Form.Group>

          {itemBlocks.map((block, index) => (
            <div
              key={index}
              className="mb-4 p-3 pt-3 position-relative"
              style={{
                border: "1px solid #D6E6FA",
                borderRadius: "10px",
                background: "#F9FBFF",
              }}
            >
              {itemBlocks.length > 1 && (
                <Button
                  size="sm"
                  variant="danger"
                  className="position-absolute top-0 end-0 m-2"
                  style={{
                    borderRadius: "10%",
                    padding: "0px 8px",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                  onClick={() =>
                    setItemBlocks((prev) => prev.filter((_, i) => i !== index))
                  }
                >
                  &times;
                </Button>
              )}

              {/* MEASUREMENT TABLE */}

              <Row className="mb-3">
                {/* ITEM */}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      Item <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      value={block.item_id}
                      onChange={(e) => {
                        const itemId = e.target.value;

                        setItemBlocks((prev) =>
                          prev.map((b, i) =>
                            i === index
                              ? {
                                  ...b,
                                  item_id: itemId,
                                  fabric_type: "",
                                  measurements: [],
                                  stock_qty: null,
                                }
                              : b,
                          ),
                        );

                        if (itemId) {
fetchItemWiseOtherJobIssueData(itemId, index, selectedActions);
                        } else {
                          setJobIssueDetails([]);
                        }
                      }}
                    >
                      <option value="">Select Item</option>

                      {items
                        .filter((i) => {
                          return !itemBlocks.some(
                            (b, idx) =>
                              idx !== index &&
                              String(b.item_id) === String(i.id),
                          );
                        })
                        .map((i) => (
                          <option key={i.id} value={i.id}>
                            {i.item_name}
                          </option>
                        ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              {/* MEASUREMENT TABLE */}
              {block.item_id && (
                <>
                  {block.loading ? (
                    <div className="text-muted text-center">
                      Loading measurements...
                    </div>
                  ) : block.jobIssueDetails.length > 0 ? (
                    <Table bordered size="sm">
                      <thead className="table-light text-center">
                        <tr>
                          <th>SL</th>
                          <th>Item</th>
                          <th>Size</th>
                          <th>No. of Measurements</th>
                          <th>Total Qty</th>
                          {/* <th>Fabric Req. (mtr)</th> */}
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {block.jobIssueDetails.map((m, idx) => (
                          <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>{m.item_name}</td>
                            <td>{m.size}</td>
                            <td>{m.measurement_count}</td>
                            <td>{m.quantity}</td>
                            {/* <td>{m.fabric_requirement ?? "-"}</td> */}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  ) : (
                    <div className="text-muted text-center">
                      No measurements found
                    </div>
                  )}
                </>
              )}
            </div>
          ))}

          <Row className="mt-3">
            <Col className="d-flex justify-content-end">
              <Button
                variant="success"
                className="fw-semibold text-white"
                onClick={handleAddMoreItem}
              >
                <i className="fa-solid fa-plus me-2"></i> Add More
              </Button>
            </Col>
          </Row>

          {/* Tentative Return Date */}
          <Form.Group className="mb-2">
            <Form.Label>
              Tentative Date of Start Returning{" "}
              <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="date"
              value={formData.tentative_return_date}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  tentative_return_date: e.target.value,
                })
              }
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={() => setShowModal(false)}>Cancel</Button>
          <Button
  variant="success"
  onClick={handleSaveSinglevendor}
  disabled={submitLoading}
>
  {submitLoading ? (
    <>
      <span className="spinner-border spinner-border-sm me-2"></span>
      Submitting...
    </>
  ) : (
    "Submit"
  )}
</Button>
        </Modal.Footer>
      </Modal>

      {/* MULTIPLE VENDOR MODAL */}
      <Modal
        show={showMultipleModal}
        size="lg"
        onHide={() => setShowMultipleModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header
          closeButton
          style={{ background: "#3399ff", color: "#fff" }}
        >
          <Modal.Title>
            Issue Stitching and Other Job Works (Multiple Organisation)
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* ISSUE DATE */}
          <Row>
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>
                  Issue Date <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  value={formData.issue_date}
                  onChange={(e) =>
                    setFormData({ ...formData, issue_date: e.target.value })
                  }
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>
                  Tentative Date of Start Returning{" "}
                  <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  value={formData.tentative_return_date}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      tentative_return_date: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
          </Row>

          {itemBlocks.map((block, index) => (
            <div
              key={index}
              className="mb-4 p-3 pt-3 position-relative"
              style={{
                border: "1px solid #D6E6FA",
                borderRadius: "10px",
                background: "#F9FBFF",
              }}
            >
              {itemBlocks.length > 1 && (
                <Button
                  size="sm"
                  variant="danger"
                  className="position-absolute top-0 end-0 m-2"
                  style={{
                    borderRadius: "10%",
                    padding: "0px 8px",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                  onClick={() =>
                    setItemBlocks((prev) => prev.filter((_, i) => i !== index))
                  }
                >
                  &times;
                </Button>
              )}

              <Row>
                <Row>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold">Selected Jobs</Form.Label>

                    <div
                      style={{
                        maxHeight: "220px",
                        overflowY: "auto",
                      }}
                    >
                      <Row>
                        {orderedActions.map((action, actionIndex) => {
                          const isChecked = block.selectedActions?.includes(
                            action.id,
                          );

                          const isDisabled =
                            !isChecked &&
                            block.selectedActions.length !== actionIndex;

                          return (
                            <Col md={4} key={action.id}>
                              <Form.Check
                                type="checkbox"
                                label={action.action_name}
                                checked={isChecked}
                                disabled={isDisabled}
                                onChange={(e) => {
                                  const checked = e.target.checked;

                                  setItemBlocks((prev) =>
                                    prev.map((b, i) => {
                                      if (i !== index) return b;

                                      let updated = [
                                        ...(b.selectedActions || []),
                                      ];

                                      if (checked) {
                                        updated.push(action.id);
                                      } else {
                                        updated = updated.slice(0, actionIndex);
                                      }

                                      return { ...b, selectedActions: updated };
                                    }),
                                  );
                                }}
                                className="mb-2"
                              />
                            </Col>
                          );
                        })}
                      </Row>
                    </div>
                  </Form.Group>
                </Row>
                <Col md={6}>
                  {/* Issue To */}
                  <Form.Group className="mb-2">
                    <Form.Label>
                      Select Organisation Type <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      value={block.issue_to || ""}
                      onChange={(e) => {
                        const value = e.target.value;

                        setItemBlocks((prev) =>
                          prev.map((b, i) =>
                            i === index
                              ? {
                                  ...b,
                                  issue_to: value,
                                  vendor_id: "",
                                  vendorList: [],
                                }
                              : b,
                          ),
                        );

                        if (value) {
                          fetchVendorsByType(value, index);
                        }
                      }}
                    >
                      <option value="">Select</option>

                      {issueToList.map((i) => (
                        <option key={i.id} value={i.id}>
                          {i.vendor_type_short_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-2">
                    <Form.Label>
                      Select Organisation <span className="text-danger">*</span>
                    </Form.Label>

                    <Form.Select
                      value={block.vendor_id || ""}
                      disabled={
                        !block.issue_to || block.vendorList.length === 0
                      }
                      onChange={(e) => {
                        const value = e.target.value;

                        setItemBlocks((prev) =>
                          prev.map((b, i) =>
                            i === index ? { ...b, vendor_id: value } : b,
                          ),
                        );

                        if (value) {
                          fetchMembersByVendor(value, index);
                        }
                      }}
                    >
                      <option value="">Select Organisation</option>

                      {block.vendorList.map((v) => (
                        <option key={v.id} value={v.id}>
                          {v.vendors_master_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              {block.memberList && block.memberList.length > 0 && (
                <div className="mt-3">
                  <h6>Members</h6>

                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>
                          <input
                            type="checkbox"
                            checked={
                              block.selectedMembers.length ===
                                block.memberList.length &&
                              block.memberList.length > 0
                            }
                            onChange={(e) => {
                              const checked = e.target.checked;

                              setItemBlocks((prev) =>
                                prev.map((b, i) =>
                                  i === index
                                    ? {
                                        ...b,
                                        selectedMembers: checked
                                          ? b.memberList.map((m) => m.user_id)
                                          : [],
                                      }
                                    : b,
                                ),
                              );
                            }}
                          />
                        </th>
                        <th>Member Name</th>
                        <th>Mobile</th>
                        <th>Beneficiary Id</th>
                      </tr>
                    </thead>

                    <tbody>
                      {block.memberList.map((member) => (
                        <tr key={member.user_id}>
                          <td>
                            <input
                              type="checkbox"
                              checked={block.selectedMembers.includes(
                                member.user_id,
                              )}
                              onChange={(e) => {
                                const checked = e.target.checked;

                                setItemBlocks((prev) =>
                                  prev.map((b, i) => {
                                    if (i !== index) return b;

                                    let updated = [...b.selectedMembers];

                                    if (checked) {
                                      updated.push(member.user_id);
                                    } else {
                                      updated = updated.filter(
                                        (id) => id !== member.user_id,
                                      );
                                    }

                                    return {
                                      ...b,
                                      selectedMembers: updated,
                                    };
                                  }),
                                );
                              }}
                            />
                          </td>
                          <td>{member.name}</td>
                          <td>{member.mobile}</td>
                          <td>{member.shg_name}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {/* MEASUREMENT TABLE */}

              <Row className="mb-3">
                {/* ITEM */}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      Item <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      value={block.item_id}
                      onChange={(e) => {
                        const itemId = e.target.value;

                        setItemBlocks((prev) =>
                          prev.map((b, i) =>
                            i === index
                              ? {
                                  ...b,
                                  item_id: itemId,
                                  fabric_type: "",
                                  measurements: [],
                                  stock_qty: null,
                                }
                              : b,
                          ),
                        );

                        if (itemId) {
fetchItemWiseOtherJobIssueData(
  itemId,
  index,
  block.selectedActions
);                        } else {
                          setJobIssueDetails([]);
                        }
                      }}
                    >
                      <option value="">Select Item</option>

                      {items
                        .filter((i) => {
                          return !itemBlocks.some(
                            (b, idx) =>
                              idx !== index &&
                              String(b.item_id) === String(i.id),
                          );
                        })
                        .map((i) => (
                          <option key={i.id} value={i.id}>
                            {i.item_name}
                          </option>
                        ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              {/* MEASUREMENT TABLE */}
              {block.item_id && (
                <>
                  {block.loading ? (
                    <div className="text-muted text-center">
                      Loading measurements...
                    </div>
                  ) : block.jobIssueDetails.length > 0 ? (
                    <Table bordered size="sm">
                      <thead className="table-light text-center">
                        <tr>
                          <th>SL</th>
                          <th>Item</th>
                          <th>Size</th>
                          <th>No. of Measurements</th>
                          <th>Total Qty</th>
                          {/* <th>Fabric Req. (mtr)</th> */}
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {block.jobIssueDetails.map((m, idx) => (
                          <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>{m.item_name}</td>
                            <td>{m.size}</td>
                            <td>{m.measurement_count}</td>
                            <td>{m.quantity}</td>
                            {/* <td>{m.fabric_requirement ?? "-"}</td> */}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  ) : (
                    <div className="text-muted text-center">
                      No measurements found
                    </div>
                  )}
                </>
              )}
            </div>
          ))}

          <Row className="mt-3">
            <Col className="d-flex justify-content-end">
              <Button
                variant="success"
                className="fw-semibold text-white"
                onClick={handleAddMoreItem}
              >
                <i className="fa-solid fa-plus me-2"></i> Add More
              </Button>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={() => setShowMultipleModal(false)}>Cancel</Button>
          <Button
  variant="success"
  onClick={handleSaveMultipleVendor}
  disabled={submitLoading}
>
  {submitLoading ? (
    <>
      <span className="spinner-border spinner-border-sm me-2"></span>
      Submitting...
    </>
  ) : (
    "Submit"
  )}
</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default IssueJobWork;
